export function reorderBooks(books, bookOrder) {
  return books.sort((a, b) => bookOrder.indexOf(a.id) - bookOrder.indexOf(b.id))
}
